import React, { FunctionComponent } from 'react';

import { cn } from '@epoch-ui/lib/utils';
import { GuestStatus } from 'types/guest.types';

import { RsvpSettings } from './RsvpStickerSettings';

export interface RsvpStickerProps {
  rsvpStatus: GuestStatus;
  customText?: string;
  className?: string;
}
export const RsvpSticker: FunctionComponent<RsvpStickerProps> = ({
  rsvpStatus,
  customText,
  className = 'tw-px-1.5 tw-py-1'
}) => {
  return (
    <div
      className={cn(
        'tw-flex tw-items-center tw-justify-center tw-gap-1 tw-rounded-rounded tw-px-1.5 tw-py-1 tw-text-sm tw-font-normal tw-leading-5',
        RsvpSettings[rsvpStatus]?.backgroundColor,
        RsvpSettings[rsvpStatus]?.textColor,
        className
      )}
    >
      <p className={`tw-m-0 tw-flex-1 tw-text-nowrap tw-leading-5`}>
        {customText || RsvpSettings[rsvpStatus]?.text}
      </p>
    </div>
  );
};
